module.exports = __webpack_public_path__ + "assets/images/player3.c448080ec479fd379034b1c1678870a1.svg";